// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu-items-m__wrapper__3pJNq"};